export class Referals{
    static vote: string = "https://rating.hh.ru/poll/";
}